/**
 * Integrations Data - UI Configuration
 *
 * This file contains UI-only configuration for integrations:
 * - Type definitions (exported to service and components)
 * - Category labels (UI config - maps category keys to display labels)
 * - Status styling config (UI config - styling for different statuses)
 *
 * NOTE: The actual integrations data array has been moved to the service layer.
 * See /src/app/services/common/integrations-service.ts for integration data.
 */

// Re-export types from service for backward compatibility
export type { IntegrationStatus, IntegrationCategory, Integration } from '../services/common/integrations-service';

// UI Config: Category display labels (stays in component/data layer)
export const INTEGRATION_CATEGORIES = {
  analytics: 'Analytics & Measurement',
  collaboration: 'Collaboration & Alerts',
  bi: 'BI & Data Warehouses',
  'web-commerce': 'Web, Commerce & CMS',
  'marketing-crm': 'Marketing & CRM',
  publishing: 'Publishing',
} as const;

// UI Config: Status styling configuration (stays in component/data layer)
export const INTEGRATION_STATUS_CONFIG = {
  live: {
    label: 'Live',
    color: 'var(--success-text)',
    bgColor: 'var(--success-bg)',
    borderColor: 'var(--success-border)',
  },
  'in-progress': {
    label: 'In Progress',
    color: 'var(--signal-blue)',
    bgColor: 'var(--signal-blue-10)',
    borderColor: 'var(--signal-blue-30)',
  },
  planned: {
    label: 'Planned',
    color: 'var(--muted-foreground)',
    bgColor: 'var(--muted)',
    borderColor: 'var(--border)',
  },
} as const;